import Cookie from 'js-cookie';
import { CookieName } from '@/shared/enums';
import domain from './get-domain';

const PROFILE_COOKIE_EXPIRE = 365;

const setProfileCookie = (profile) => {
  Cookie.set(CookieName.PROFILE_UID, profile.uid, {
    expires: PROFILE_COOKIE_EXPIRE,
    domain,
  });
};

export { setProfileCookie };
